import React, {Component} from 'react'
import PropTypes from 'prop-types'

class PrinterColumn extends Component {

    _handleRenderPrinterItem = (name, side) => {
        return (
            <>
            {
                side.map(item => {
                    return (
                        <div className='printer-item'>
                            {item} : {name}
                        </div>
                    )
                })
            }
            </>
        )
    }

    render() {
        const {printer} = this.props
        const name = printer ? printer.name : ''
        const side = printer ? printer.side : []

        return <td className="printer">
            {
                side && side.length > 0 ? this._handleRenderPrinterItem(name, side) : ''
            }
            
        </td>
    }
}

PrinterColumn.propTypes = {
    printer: PropTypes.object
}

export default PrinterColumn